import { MoreHorizontal } from 'lucide-react'
import { useTranslation } from '@kostbar/i18n'
import type { ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

type RowActionsProps = {
  children?: ReactNode
}

// Generic row actions trigger. Consumers can pass items as children.
export function RowActions({ children }: RowActionsProps) {
  const { t: tUi } = useTranslation('ui')
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0">
          <MoreHorizontal className="h-4 w-4" />
          <span className="sr-only">{tUi('rowActions.openMenu')}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {children ?? (
          <>
            <DropdownMenuLabel>{tUi('rowActions.actions')}</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem disabled>
              {tUi('rowActions.noActions')}
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
